import { STATIC_URL } from '../../api/urls';
import { documentActionPanelOpenState } from '../../atoms/layout';
import PanelContainer from '../common/PanelContainer';

interface Props {
  className?: string;
  documents: {
    id: string;
    creator: { fullName: string };
    createdAt: string;
    address: string;
  }[];
}

export default function DocumentHistoryPanel({ documents, className }: Props) {
  return (
    <PanelContainer
      heightState={documentActionPanelOpenState}
      title="تاریخجه فایل‌ها"
      className={className}
    >
      {!!documents && documents.length === 0 && (
        <div className="text-center text-zinc-600 text-sm">هنوز فایلی ثبت نشده است.</div>
      )}
      <div className="space-y-1 divide-y-2 divide-slate-300">
        {documents?.map((doc) => (
          <div
            className="flex flex-row justify-between p-1 text-sm 
           text-zinc-600 cursor-pointer hover:brightness-50 transition-all"
            key={doc.id}
          >
            <div className="after:text-primary-400 after:pr-3 hover:after:content-['(مشاهده)']">
              <a href={STATIC_URL + doc.address} download target="_blank" rel="noreferrer">
                {doc.creator.fullName}
              </a>
            </div>
            <div className="text-zinc-500">
              {new Date(doc.createdAt).toLocaleString('fa-IR', {
                dateStyle: 'medium',
                timeStyle: 'short'
              })}
            </div>
          </div>
        ))}
      </div>
    </PanelContainer>
  );
}
